import orderBy from 'lodash/orderBy';

import { store } from '@store';
import { SortingOrder } from '@store/types';

import { useAccountantLegalEntities } from '../../../hooks/useAccountantLegalEntities';
import { OrganizationRow } from './useColumns';

interface LegalEntityWithOrganizations {
    legalEntityId: string;
    name: string;
    organizations: OrganizationRow[];
}

interface Data {
    data: LegalEntityWithOrganizations[];
}

export function useTableData(): Data {
    const legalEntities = useAccountantLegalEntities();
    const { legalEntityBranchList, organizationList } = store;

    const data = legalEntities.map(item => {
        const legalEntityOrganizationIDS = legalEntityBranchList.getLegalEntityOrganizationIds(item.id);
        const organizations: OrganizationRow[] = legalEntityOrganizationIDS
            .map(orgId => organizationList.getExisting(orgId))
            .map(organization => ({
                id: organization.id,
                name: organization.name,
                storeId: organization.storeId ?? '',
            }));

        return {
            legalEntityId: item.id,
            name: item.name,
            organizations: orderBy(organizations, ['name'], [SortingOrder.ASC]),
        };
    });

    return { data };
}
